import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import { Icon } from "design-system/components/icons/icon";
import { LinkProps } from "design-system/components/primitives/link/link";
import { Dispatch, FC, SetStateAction } from "react";
import { ExpandedNavigationLinkWithSubItems } from "../local/expanded-local-navigation";
import { PageList } from "./page-list";

interface PageListWrapperProps {
  pageList: ExpandedNavigationLinkWithSubItems;
  tab: number;
  layout: "vertical" | "horizontal";
  singleTopLink?: LinkProps;
  setTabOpen: Dispatch<SetStateAction<string>>;
  tabOpen: string;
}

export const PageListWrapper: FC<PageListWrapperProps> = ({
  layout,
  pageList,
  tab,
  singleTopLink,
  setTabOpen,
  tabOpen,
}) => {
  if (layout === "horizontal") {
    const { title } = pageList;
    const value = `tab-${tab}`;
    return (
      <NavigationMenu.Item key={tab} value={value}>
        {title && (
          <NavigationMenu.Trigger
            onPointerMove={(event) => event.preventDefault()}
            onPointerLeave={(event) => event.preventDefault()}
            value={title}
            onClick={() =>
              tabOpen === value ? setTabOpen("") : setTabOpen(value)
            }
            /*
              When the keyboard navigation leaves the content and
              goes to the next menu, the dropdown closes.
              This is "onFocus" and not "onBlur" because "onBlur"
              triggers when the focus leaves the menu button to the component
            */
            onFocus={() => setTabOpen("")}
            asChild
          >
            <button className="expanded-navigation__subitem-link">
              {title}
              <Icon
                name="caret"
                className="expanded-navigation__item-caret"
                aria-hidden
              />
            </button>
          </NavigationMenu.Trigger>
        )}

        <NavigationMenu.Content>
          <div className="expanded-navigation-content-wrapper-submenu">
            <PageList pageList={pageList} layout={layout} />
          </div>
        </NavigationMenu.Content>
      </NavigationMenu.Item>
    );
  }

  return (
    <PageList
      pageList={pageList}
      layout={layout}
      singleTopLink={singleTopLink}
    />
  );
};
